import { useState } from 'preact/hooks';
import { useApp } from '../../app/context';
import { ru } from '../../i18n/ru';
import { Button } from '../components/Button';
import './NoticeScreen.css';

interface NoticeProps {
  emoji: string;
  title: string;
  text: string;
  action: string;
  busyAction?: string;
  onAction(): void | Promise<void>;
}

/** Full-screen message with one big button (blocking situations). */
function Notice({ emoji, title, text, action, busyAction, onAction }: NoticeProps) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await onAction();
    } finally {
      setBusy(false);
    }
  };
  return (
    <main class="screen notice">
      <div class="notice__card panel">
        <div class="notice__emoji" aria-hidden="true">
          {emoji}
        </div>
        <h1 class="notice__title title-text">{title}</h1>
        <p class="notice__text">{text}</p>
        <Button variant="green" size="big" block disabled={busy} onClick={() => void run()}>
          {busy && busyAction ? busyAction : action}
        </Button>
      </div>
    </main>
  );
}

/** The same player opened the game somewhere else; offer to take the session back. */
export function ReplacedScreen() {
  const app = useApp();
  return (
    <Notice
      emoji="📱"
      title={ru.replaced.title}
      text={ru.replaced.text}
      action={ru.replaced.button}
      onAction={() => app.takeOver()}
    />
  );
}

/** The server speaks a newer protocol: fetch the new version and reload. */
export function UpdateScreen() {
  const app = useApp();
  return (
    <Notice
      emoji="🚀"
      title={ru.update.title}
      text={ru.update.text}
      action={ru.update.button}
      busyAction={ru.update.updating}
      onAction={() => app.updater.updateAndReload()}
    />
  );
}
